<p-dialog
    (onHide)="onHide()"
    (onShow)="onShow()"
    [(visible)]="visible"
    [appendTo]="appendTo"
    [closable]="false"
    [contentStyle]="contentStyle"
    [dismissableMask]="dismissOnClickOutside"
    [draggable]="draggable"
    [minX]="minX"
    [minY]="minY"
    [modal]="blockBackground"
>
    <ng-template #header> {{ "applications.createResult.title" | translate }} </ng-template>

    @if (clientCreatedResult) {
    <div class="application-create-result-dialog">
        <div class="info">{{"applications.createResult.info" | translate}}</div>
        <h3>{{"applications.clientId" | translate}}</h3>
        <div class="block">
            <a (click)="copyIdToClipboard()">
                <app-svg-icon icon="copy"></app-svg-icon>
                {{clientCreatedResult.id}}
            </a>
        </div>
        <h3>{{"applications.clientSecret" | translate}}</h3>
        <div class="block">
            <a (click)="copySecretToClipboard()">
                <app-svg-icon icon="copy"></app-svg-icon>
                {{clientCreatedResult.secret}}
            </a>
        </div>
    </div>
    }

    <ng-template #footer>
        <button
            class="m-btn m-btn-primary"
            (click)="close()"
            [disabled]="!copiedSecret"
            type="submit"
        >
            {{ "form.close" | translate }}
        </button>
    </ng-template>
</p-dialog>
